import { Component, HostListener, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../services/analytics.service';

interface NavDropdownItem {
  label: string;
  description?: string;
  icon: string;
  action: () => void;
}

interface NavDropdown {
  key: string;
  label: string;
  items: NavDropdownItem[];
}

@Component({
  selector: 'app-vitrine-navbar',
  templateUrl: './vitrine-navbar.component.html',
  styleUrls: ['./vitrine-navbar.component.scss'],
})
export class VitrinenNavbarComponent implements OnDestroy {
  isScrolled = false;
  isMenuOpen = false;
  activeDropdown: string | null = null;

  @HostListener('window:scroll')
  onScroll() {
    this.isScrolled = window.scrollY > 60;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest || !target.closest('.nav-dropdown-wrapper')) {
      this.activeDropdown = null;
    }
  }

  navDropdowns: NavDropdown[] = [
    {
      key: 'produit',
      label: 'Produit',
      items: [
        {
          label: 'Fonctionnalités',
          description: 'Tout ce que SGMAO peut faire',
          icon: 'pi pi-th-large',
          action: () => this.navigateToSection('features'),
        },
        {
          label: 'Comment ça marche',
          description: 'Opérationnel en 3 étapes',
          icon: 'pi pi-play-circle',
          action: () => this.navigateToSection('workflow'),
        },
        {
          label: 'Gestion des rôles',
          description: 'Créez et attribuez vos accès',
          icon: 'pi pi-shield',
          action: () => this.navigateToSection('gestion-roles'),
        },
        {
          label: 'Assistant IA',
          description: 'Votre copilote maintenance',
          icon: 'pi pi-bolt',
          action: () => this.navigateToSection('ai-assistant'),
        },
        {
          label: 'Sécurité & Infrastructure',
          description: 'Données protégées, SLA 99,9%',
          icon: 'pi pi-lock',
          action: () => this.navigateToSection('techniquement'),
        },
      ],
    },
    {
      key: 'solutions',
      label: 'Solutions',
      items: [
        {
          label: 'Hôpitaux & Santé',
          description: 'Équipements biomédicaux, audits',
          icon: 'pi pi-heart',
          action: () => this.router.navigate(['/public/solutions/hopital']),
        },
        {
          label: 'Industries & Usines',
          description: 'Production, MTTR, MTBF, stocks',
          icon: 'pi pi-cog',
          action: () => this.router.navigate(['/public/solutions/industrie']),
        },
        {
          label: 'Collectivités & Mairies',
          description: 'Patrimoine public, multi-sites',
          icon: 'pi pi-building',
          action: () => this.router.navigate(['/public/solutions/collectivite']),
        },
      ],
    },
  ];

  constructor(private router: Router, private analytics: AnalyticsService) {}

  ngOnDestroy(): void {}

  toggleDropdown(key: string, event: MouseEvent): void {
    event.stopPropagation();
    this.activeDropdown = this.activeDropdown === key ? null : key;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    this.activeDropdown = null;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  navigateToSection(sectionId: string): void {
    this.closeMenu();
    const currentUrl = this.router.url;
    if (currentUrl === '/' || currentUrl === '') {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      this.router.navigate(['/'], { fragment: sectionId });
    }
  }

  goToLogin(): void {
    this.closeMenu();
    this.router.navigate(['/login']);
  }

  goToRegister(): void {
    this.closeMenu();
    this.analytics.trackEvent('cta_essai_gratuit', { source: 'navbar' });
    this.router.navigate(['/login']);
  }

  goToContact(): void {
    this.closeMenu();
    this.router.navigate(['/public/contact']);
  }

  scrollToPricing(): void {
    this.closeMenu();
    const currentUrl = this.router.url;
    if (currentUrl === '/' || currentUrl === '') {
      const el = document.getElementById('pricing');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      this.router.navigate(['/'], { fragment: 'pricing' });
    }
  }
}
